import React from 'react'

export default function DocumentsIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8.41421C20 7.88378 19.7893 7.37507 19.4142 7L15 2.58579C14.6249 2.21071 14.1162 2 13.5858 2H6ZM6 4H13V8C13 8.55228 13.4477 9 14 9H18V20H6V4ZM15 4.41421L17.5858 7H15V4.41421Z" fill="currentColor"/>
        </svg>
    )
}
